import { render, staticRenderFns } from "./EmptyTemplates.vue?vue&type=template&id=4fb34671&"
import script from "./EmptyTemplates.vue?vue&type=script&lang=js&"
export * from "./EmptyTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports